"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    UserCheckSolid: function() {
        return UserCheckSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const UserCheckSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsxs)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M7 6C7 3.23858 9.23858 1 12 1C14.7614 1 17 3.23858 17 6C17 8.76142 14.7614 11 12 11C9.23858 11 7 8.76142 7 6Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M2 22C2 16.4772 6.47715 12 12 12C15.2093 12 18.0655 13.5118 19.8953 15.8622L19.8787 15.8787L17.9966 17.7608C16.8186 16.7085 15.0095 16.7478 13.8787 17.8787C12.7071 19.0503 12.7071 20.9497 13.8787 22.1213L14.7574 23H3C2.44772 23 2 22.5523 2 22Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M22.7071 18.7071C23.0976 18.3166 23.0976 17.6834 22.7071 17.2929C22.3166 16.9024 21.6834 16.9024 21.2929 17.2929L18 20.5858L16.7071 19.2929C16.3166 18.9024 15.6834 18.9024 15.2929 19.2929C14.9024 19.6834 14.9024 20.3166 15.2929 20.7071L17.2929 22.7071C17.6834 23.0976 18.3166 23.0976 18.7071 22.7071L22.7071 18.7071Z",
            fill: "currentColor"
        })
    ]
}), "UserCheckSolid");
const _default = UserCheckSolid;
